import React from 'react'
import "./HosAnalysis.css"
import Photo from "../../../../Assests/Products/Hospitalmang/Screenshot (24).png"
const HosAnalysis = () => {
    return (
        <div className='HosAnalysis'>
            <div className="HosAnalysis-Photo" data-aos="zoom-in-right">
                <img src={Photo} alt='' />
            </div>
            <div className="HosAnalysis-Def" data-aos="zoom-in-right">
                <h2>
                    Real Time Data Analysis
                </h2>
                <p>
                    DynamicEMR empowers healthcare providers with real-time data analysis, transforming raw data into actionable insights instantly. This feature helps in monitoring patient health trends, optimizing resource allocation, and enhancing decision-making processes. By analyzing data
                </p>

            </div>
        </div>
    )
}

export default HosAnalysis